import { render, staticRenderFns } from "./seat_map_pax.vue?vue&type=template&id=604b9799&"
import script from "./seat_map_pax.vue?vue&type=script&lang=js&"
export * from "./seat_map_pax.vue?vue&type=script&lang=js&"
import style0 from "./seat_map_pax.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports